import ClientCourseSessions from './ClientCourseSessions';

export default ClientCourseSessions;
